module.exports = __webpack_public_path__ + "img/ski6.042b22ef.jpg";